import React, {useEffect} from 'react'
import {toAbsoluteUrl} from 'src/marketConnect/helpers'
import {bigcommerceGetURL} from 'src/redux/actions/bigCommerceActions'
import {useAppDispatch} from 'src/redux/storeHooks'
import {useLocation} from 'react-router-dom'
import useAppToast from 'src/hooks/useAppToast'

export default function CommerciumLandingPage() {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const {successToast, errorToast} = useAppToast()
  const parm = location.search
  const [commerciumurl, setCommerciumurl] = React.useState<string>('')

  const searchParams = new URLSearchParams(location.search)
  const eventType = searchParams.get('event')?.toLowerCase() || ''
  const isSignup = eventType === 'signup'

  const handleNavigateToCommercium = () => {
    const url = commerciumurl ? commerciumurl : 'https://commercium.constacloud.com/auth'
    window.open(url, '_blank')
  }

  const commerceiumURLapi = async () => {
    try {
      await dispatch(bigcommerceGetURL({parm})).then((response) => {
        if (response.payload?.status_code === 200) {
          successToast(response.payload?.massage)
          setCommerciumurl(response?.payload?.data?.redirect_url)
        } else {
          errorToast(response?.payload?.data?.message)
        }
      })
    } catch (err) {
      console.log('error in fetching commercium url', err)
    }
  }

  useEffect(() => {
    commerceiumURLapi()
  }, [parm])

  const heading = isSignup ? 'BigCommerce Connected Successfully!' : 'Welcome to Commercium'
  const subheading = isSignup
    ? "You're one step away from activating your automation engine."
    : 'Manage your BigCommerce connection and automation rules.'
  const ctaLabel = isSignup ? 'Start Setup on Commercium Portal' : 'Go to Commercium Portal'
  const sectionTitle = isSignup ? 'Next Step: Launch Your Portal' : 'Launch Your Dashboard'
  const sectionCopy = isSignup
    ? 'You must navigate to the Commercium Portal to set up your first rules, finalize your synchronization settings, and go live.'
    : 'Click the button below to open the Commercium Portal in a new tab and access your settings and data synchronization reports.'
  const footerNote = isSignup
    ? 'You will be redirected to the Commercium Portal to complete the final steps.'
    : 'This will open the application in a new browser tab.'

  return (
    <div
      className='min-vh-100 d-flex align-items-center justify-content-center position-relative px-3'
      style={{
        background: 'linear-gradient(135deg, #111b3a 0%, #2a3784 40%, #2d5cff 100%)',
      }}
    >
      <div
        className='position-absolute rounded-circle'
        style={{
          width: '220px',
          height: '220px',
          background: 'rgba(255,255,255,0.08)',
          top: '8%',
          left: '6%',
          filter: 'blur(2px)',
        }}
      />
      <div
        className='position-absolute rounded-circle'
        style={{
          width: '320px',
          height: '320px',
          background: 'rgba(255,255,255,0.05)',
          bottom: '5%',
          right: '8%',
          filter: 'blur(3px)',
        }}
      />

      <div className='container-fluid position-relative' style={{zIndex: 1}}>
        <div className='row justify-content-center'>
          <div className='col-12 col-md-10 col-lg-8 col-xl-6 col-xxl-5'>
            <div
              className='bg-white p-5 p-md-5 text-center shadow-lg'
              style={{
                borderRadius: '18px',
                boxShadow: '0 20px 45px rgba(0,0,0,0.2)',
              }}
            >
              <div className='mb-4 d-flex justify-content-center'>
                <div
                  className='d-flex align-items-center justify-content-center'
                  style={{
                    width: '72px',
                    height: '72px',
                    borderRadius: '16px',
                    background: '#e6f3fb',
                  }}
                >
                  <img
                    alt='Commercium icon'
                    src={toAbsoluteUrl('/media/logos/favicon.png')}
                    style={{height: '48px', width: '48px'}}
                  />
                </div>
              </div>

              <h1 className='fw-bold mb-3' style={{fontSize: '2rem'}}>
                {heading}
              </h1>
              <p className='text-secondary mb-4' style={{fontSize: '1rem'}}>
                {subheading}
              </p>

              {isSignup && (
                <div
                  className='d-flex align-items-start gap-3 p-3 mb-4 text-start'
                  style={{
                    border: '1px solid #e6eaf3',
                    borderRadius: '12px',
                    background: '#f8fbff',
                  }}
                >
                  <div
                    className='d-flex align-items-center justify-content-center'
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '10px',
                      background: '#e8f5ec',
                      color: '#2bb24c',
                    }}
                  >
                    <svg
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2.2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path d='M20 6L9 17l-5-5' />
                    </svg>
                  </div>
                  <div>
                    <div className='fw-semibold mb-1'>Commercium is Ready</div>
                    <div className='text-secondary' style={{fontSize: '0.95rem'}}>
                      Your BigCommerce permissions (Orders, Products, etc.) have been authorized and
                      secured.
                    </div>
                  </div>
                </div>
              )}

              <div className='text-start mb-4'>
                <h5 className='fw-bold mb-2'>{sectionTitle}</h5>
                <p className='text-secondary mb-0' style={{fontSize: '0.98rem'}}>
                  {sectionCopy}
                </p>
              </div>

              <div className='d-grid'>
                <button
                  type='button'
                  className='btn btn-lg text-white fw-semibold'
                  onClick={handleNavigateToCommercium}
                  style={{
                    backgroundColor: '#0084c7',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 12px 24px rgba(0, 132, 199, 0.35)',
                  }}
                >
                  <div className='d-flex align-items-center justify-content-center gap-2'>
                    <svg
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2.2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path d='M5 12h14' />
                      <path d='M13 5l7 7-7 7' />
                    </svg>
                    <span>{ctaLabel}</span>
                  </div>
                </button>
              </div>

              <div className='mt-4'>
                <small className='text-muted' style={{fontSize: '0.9rem'}}>
                  {footerNote}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
